import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBBtn, MDBIcon, MDBView } from "mdbreact";
import { SetCREATE } from "../../../../../services/redux/slices/diagnostics/clinic/clinicSupplies";
import { SetSelectedMonth, SetSelectedYear } from "../../../../../services/redux/slices/diagnostics/clinic/clinicInventory";
import {
  filterSupplyGroupsByMonthYear,
  getMonthOptions,
  getYearOptions,
  groupInventoriesBySupply,
} from "./utils";

export default function Header() {
  const dispatch = useDispatch();
  const {
    collections = [],
    selectedMonth,
    selectedYear,
  } = useSelector(({ clinicInventory }) => clinicInventory);

  const groupedSupplies = React.useMemo(
    () => groupInventoriesBySupply(collections),
    [collections],
  );
  const filteredGroups = React.useMemo(
    () =>
      filterSupplyGroupsByMonthYear(
        groupedSupplies,
        selectedMonth,
        selectedYear,
      ),
    [groupedSupplies, selectedMonth, selectedYear],
  );
  const monthOptions = React.useMemo(() => getMonthOptions(), []);
  const yearOptions = React.useMemo(
    () => getYearOptions(groupedSupplies),
    [groupedSupplies],
  );
  const inventoryCount = filteredGroups.reduce(
    (sum, group) => sum + Number(group?.inventoryCount || 0),
    0,
  );

  return (
    <MDBView
      cascade
      className="gradient-card-header blue-gradient narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center flex-wrap"
      style={{ gap: "12px" }}
    >
      <div className="d-flex align-items-center flex-wrap" style={{ gap: "10px" }}>
        <span className="white-text mx-3 text-nowrap mt-0">
          {filteredGroups.length} supplies | {inventoryCount} inventory entries
        </span>
        <MDBBtn
          size="sm"
          color="light"
          className="m-0 px-3"
          onClick={() =>
            dispatch(
              SetCREATE({
                clinic: filteredGroups[0]?.supply?.clinic?._id || "",
              }),
            )
          }
        >
          <MDBIcon icon="plus" className="mr-1" />
          Add Supply
        </MDBBtn>
      </div>

      <div
        className="d-flex align-items-center"
        style={{ gap: "8px", flexWrap: "nowrap" }}
      >
        <select
          className="form-control"
          style={{ minWidth: "160px", width: "160px" }}
          value={selectedMonth}
          onChange={(event) =>
            dispatch(SetSelectedMonth(Number(event.target.value)))
          }
        >
          {monthOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <select
          className="form-control"
          style={{ minWidth: "120px", width: "120px" }}
          value={selectedYear}
          onChange={(event) =>
            dispatch(SetSelectedYear(Number(event.target.value)))
          }
        >
          {yearOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    </MDBView>
  );
}
